import React from "react";
import "./divider-subtitle.css";
import { Tooltip } from "@progress/kendo-react-tooltip";

const DividerSubtitle = ({ subtitle, tooltipText, positionTooltip }) => {
  return (
    <div className="subtitle">
      <div className="input-label-title-h3">
        <label>{subtitle}</label>
        {tooltipText && (
          <Tooltip
            openDelay={100}
            position={positionTooltip ? positionTooltip : "right"}
            anchorElement="target"
          >
            <div
              style={{
                textAlign: "center",
              }}
            >
              <span
                title={tooltipText}
                class="tooltip-icon k-icon k-icon-48 k-i-information"
              />
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default React.memo(DividerSubtitle);
